<script lang="ts">

    export let primary = false;
    export let secondary = false;
    export let large = false;
    export let onClick = null;
    export let classList:string[]=[''];
    export let loading = false;
    export let hidden = false;

    let primaryIcon = 'icons/icon_top_more3.svg';
    let secondaryIcon = 'icons/icon_top_more2.svg';
    const icon = () => primary ? primaryIcon : secondaryIcon;

</script>

<button class={`button ${classList.join(' ')}`}
        class:primary
        class:secondary
        class:large
        class:loading
        class:hidden
        style={`background-image: url('${icon()}')`}
        on:click={onClick}>
        <slot></slot>
</button>

<style>
    :global(.button) {
        padding: 20px;
        font-family: inherit;
        width: 100%;
        line-height: 10%;
    }

    :global(.button.redirect-button) {
        width: 50%;
    }

    :global(.button.secondary) {
        font-size: 1rem;
        font-weight: normal;
        padding-top: 15px;
        padding-right: 25px;
        background-position: right center;
        background-size: 15px;
        background-repeat: no-repeat;
        background-color: transparent;
        border: none;
    }

    :global(.button.primary) {
        border: none;
        color: white;
        font-size: 1rem;
        font-weight: normal;
        padding: 15px 25px 16px 25px;
        background-position: 95% center;
        background-size: 15px;
        background-repeat: no-repeat;
        background-color: var(--primary-color);
    }

    :global(.button.primary:hover) {
        background-color: var(--primary-hover-color);
    }


</style>